import { WORKLOAD_REQUEST } from "./utilities";
import { GetRequest, PostRequest } from "../api/genericApiCalls";
import { APP_SETTINGS } from "../../config";
import { request, success, failure } from "./utilities";
import {
  getEmployeeList,
  getEmployeeWorkLoadByUserIdApi,
  getProjectList,
  getTaskDetailsByUserIdApi,
  getWorkLoadEmployeeListByProjectId,
  getWorkLoadTaskList,
} from "../api";

export function getSideBarAction(token) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_SIDBAR_REQUEST));
    var path = APP_SETTINGS.API_PATH.WORKLOAD.getSideBar;
    GetRequest(path, token).then(
      (res) => {
        // console.log('workload response ::', res);
        if (res.data.status === 1) {
          dispatch(success(WORKLOAD_REQUEST.GET_SIDBAR_SUCCESS, res.data.data));
        } else {
          dispatch(
            failure(WORKLOAD_REQUEST.GET_SIDBAR_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_SIDBAR_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function GetEmployeeWorkloadAction(dateFilter, token) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_EMPWORKLOAD_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.WORKLOAD.getEmpWorkload}?dateFilter=${dateFilter}`;
    GetRequest(path, token).then(
      (res) => {
        // console.log('EMPLOYEE WORKLOAD ::', res);
        if (res.data.status === 1) {
          dispatch(
            success(WORKLOAD_REQUEST.GET_EMPWORKLOAD_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(WORKLOAD_REQUEST.GET_EMPWORKLOAD_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_EMPWORKLOAD_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

//Get Employee List Action

export function getEmployeesList(data) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_EMPLOYEE_LIST_REQUEST));
    getEmployeeList(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(
            success(
              WORKLOAD_REQUEST.GET_EMPLOYEE_LIST_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_EMPLOYEE_LIST_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_EMPLOYEE_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// Get All Project List Action
export function getProjectsList(data) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_PROJECT_LIST_REQUEST));
    getProjectList(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(
            success(
              WORKLOAD_REQUEST.GET_PROJECT_LIST_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_PROJECT_LIST_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_PROJECT_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// Get Task List Action
export function getTasksList(data) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_TASK_LIST_REQUEST));
    getWorkLoadTaskList(data).then(
      (response) => {
        // //  ;
        if (response.data.status === 200) {
          dispatch(
            success(WORKLOAD_REQUEST.GET_TASK_LIST_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_TASK_LIST_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_TASK_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// Get Employee List By Project Id
export function getEmployeesListByProjectIdAction(data) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_REQUEST));
    getWorkLoadEmployeeListByProjectId(data).then(
      (response) => {
        //  ;
        if (response.data.status === 200) {
          dispatch(
            success(
              WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getEmployeeWorkLoadByUserIdAction(data) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_REQUEST));
    getEmployeeWorkLoadByUserIdApi(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(
            success(
              WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getTaskDetailsByUserIdAction(data) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_REQUEST));
    getTaskDetailsByUserIdApi(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(
            success(
              WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function SaveEmployeeCommentAction(reqObject, token, indexInfo) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.todoComment, reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_SUCCESS,
              res.data.data,
              indexInfo
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function UpdateEmployeeCommentAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.todoComment, reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DeleteEmployeeCommentAction(commentId, info, token) {
  // console.log("commentid22", commentId);
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TODO.todoDeleteComment}?commentId=${commentId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_SUCCESS,
              commentId,
              info
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getEmployeeCommentsAction(taskId, token) {
  // console.log("get comments api called", taskId);
  return (dispatch) => {
    dispatch(request(WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TODO.getTodoComments}?taskId=${taskId}`;
    PostRequest(path, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
